import defs from '../../_core/defs.js';
// returns already rendered node of an object in given array
// selfDef is given instead of  itself (array) for perf optimisation
export default function getAlreadyRendered(_ref) {
  var item = _ref.item,
    selfDef = _ref.selfDef;
  var itemDef = defs.get(item);
  var selfId = selfDef.id;
  // if item object is defined in object defs
  if (itemDef) {
    var renderedInArrays = itemDef.renderedInArrays;
    // if item's node is already rendered for an array then return it
    if (renderedInArrays != null && renderedInArrays[selfId]) {
      var node = renderedInArrays[selfId];
      return node.__replacedByNode || node;
    }
  }
  return undefined;
}